export default "__VITE_ASSET__ec39fdf6__"